import React, { Component } from 'react';
import { getStyleValue, fetchJson, patchJson } from '../Helpers/Helpers';
import cookie from 'js-cookie';

import Done from '@mui/icons-material/Done';

import './Lister.css';

import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	FormControl,
	FormControlLabel,
	MenuItem,
	Select,
	RadioGroup,
	Radio,
} from '@mui/material';

class Lister extends Component {
	render () {
		return (
			<ul className="lister">
				{this.props.children}
			</ul>
		);
	}
}

class ListItem extends Component {
	constructor(props) {
		super(props);

		this.state = {
			disabled: props.disabled || false
		}
	}
	componentDidMount () {
		this.liElement.addEventListener('toggle-disabled', this.toggleDisabledState.bind(this));
	}
	componentWillUnmount () {
		this.liElement.removeEventListener('toggle-disabled', this.toggleDisabledState.bind(this));
	}
	toggleDisabledState () {
		this.setState({ disabled: !this.state.disabled });
	}

	render () {
		return (
			<li id={this.props.id}
				className={`${this.state.disabled ? 'disabled' : ''}`}
				ref={li => { this.liElement = li; }}>
				{this.props.children}
			</li>
		);
	}
}

class ListerInspection extends Component {
	render () {
		return (
			<div className="lister-left">
				{this.props.label}
				<p className="lister-secondary-text">
					{this.props.address}
				</p>
				<p className="lister-secondary-text">
					{this.props.t.lister_installation_number} <strong>{this.props.installation}</strong>
				</p>
				<p className="lister-secondary-text">
					{this.props.t.inspection_type} <strong>{this.props.inspectionType}</strong>
				</p>
			</div>
		);
	}
}

class ListerInstallation extends Component {
	render () {
		return (
			<div className="lister-left">
				{this.props.label}
				<p className="lister-secondary-text">
					{this.props.subtitle}
				</p>
			</div>
		);
	}
}

class ListerActions extends Component {
	constructor(props) {
		super(props);

		this.state = {
			dialogOpen: false,
			inspectors: [],
			inspectorId: '',
			radioValue: 'reschedule',
			isOnline: true,
			disabled: false
		}
	}

	componentDidMount () {
		this._mounted = true;
		window.addEventListener('online', this.handleOnlineEvent.bind(this));
		window.addEventListener('offline', this.handleOnlineEvent.bind(this));
	}
	componentWillUnmount () {
		this._mounted = false;
		window.removeEventListener('online', this.handleOnlineEvent);
		window.removeEventListener('offline', this.handleOnlineEvent);
	}
	handleOnlineEvent (event) {
		if (this._mounted) {
			this.setState({ isOnline: (event.type === 'online') });
		}
	}
	startInspection () {
		this.props.history.push(`inspection/${this.props.id}/${this.props.title}/${this.props.t.menu_installation}`);
	}
	cancelInspection () {
		this.setState({ dialogOpen: true });
		if (!this.state.inspectors.length) {
			fetchJson('employees?inspector=1').then(json => {
				const inspectorName = cookie.get('name')
				const currentInspector = json.data.filter(inspector => {
					return inspector.employee_fullname === inspectorName
				})[0]
				return this.setState({
					inspectors: json.data || [],
					inspectorId: currentInspector.DT_RowId,
				});
			});
		}
	}
	handleClose () {
		this.setState({ dialogOpen: false });
	}
	handleSave () {
		const radioValue = this.state.radioValue;
		const data = {
			status: radioValue,
			employee_id: radioValue === 'inspector' ? this.state.inspectorId : null
		};

		this.setState({ disabled: true }, () => {
			patchJson(data, `inspections/${this.props.id}`).then(response => {
				if (response.ok) {
					// Set disabled state to the parent (li) element
					const parentElement = document.getElementById(this.props.id);
					parentElement.dispatchEvent(new Event('toggle-disabled'));
				} else {
					// When the call fails don't keep it in disabled state
					this.setState({ disabled: false });
				}
				this.handleClose();
			});
		});
	}
	handleChange (event) {
		this.setState({ inspectorId: event.target.value });
	}
	radioChange (event, value) {
		this.setState({ radioValue: value });
	}

	render () {
		const styles = {
			radioButtonGroup: {
				paddingTop: getStyleValue('spacing-default')
			},
		}

		const inspectorList = this.state.inspectors.map((inspector) => (
			<MenuItem key={inspector.DT_RowId} value={inspector.DT_RowId}>
				{inspector.employee_fullname}
			</MenuItem>
		));

		return (
			<div className="lister-right">
				<Button
					onClick={this.cancelInspection.bind(this)}
					hidden={this.props.done}
					disabled={!this.state.isOnline || this.state.disabled}
					color="primary"
					variant="text"
				>
					{this.props.t.lister_inspection_no_excecute}
				</Button>
				<Button
					onClick={this.startInspection.bind(this)}
					className="button-raised"
					disabled={this.state.disabled}
					style={this.props.done ? { backgroundColor: getStyleValue('color-green') } : null}
					color="primary"
					variant="contained"
				>
					{this.props.done && <Done color="inherit" style={{ marginRight: '10px' }} />}
					{this.props.done ? this.props.t.lister_inspection_completed : this.props.t.lister_inspection_start}
				</Button>

				<Dialog
					open={this.state.dialogOpen}
					onClose={this.handleClose.bind(this)}
					fullWidth={true}
					maxWidth="sm"
					PaperProps={{ className: 'card dialog' }}
				>
					<DialogTitle id="form-dialog-title">{this.props.t.lister_cancel_inspection}</DialogTitle>

					<DialogContent>
						<DialogContentText>
							{this.props.t.lister_cancel_info} <span style={{ color: getStyleValue('color-primary'), fontWeight: 'bold' }}>{this.props.title}</span> ?
						</DialogContentText>

						<FormControl variant="standard" component="fieldset">
							<RadioGroup
								name="status"
								value={this.state.radioValue}
								onChange={this.radioChange.bind(this)}
								style={styles.radioButtonGroup}
							>
								<FormControlLabel
									classes={{ label: "radio-control" }}
									value="reschedule"
									control={<Radio color="primary" />}
									label={this.props.t.lister_plan_again}
								/>

								<FormControlLabel
									classes={{ label: "radio-control" }}
									value="unable"
									control={<Radio color="primary" />}
									label={this.props.t.lister_executable}
								/>

								<FormControlLabel
									classes={{ label: "radio-control" }}
									value="inspector"
									className="lister-radio-inline"
									control={<Radio disabled={!this.state.inspectors.length} color="primary" />}
									label={this.props.t.lister_assign_inspector}
								/>
							</RadioGroup>

							<Select
								variant="standard"
								value={this.state.inspectorId}
								onChange={this.handleChange.bind(this)}
								disabled={this.state.radioValue !== 'inspector'}
								displayEmpty
								name="week">
								{inspectorList}
							</Select>
						</FormControl>
					</DialogContent>

					<DialogActions>
						<Button
							onClick={this.handleClose.bind(this)}
							style={{ marginRight: getStyleValue('spacing-default') }}
							color="primary"
							variant="text"
						>
							{this.props.t.close}
						</Button>
						<Button
							onClick={this.handleSave.bind(this)}
							color="primary"
							variant="contained"
						>
							{this.props.t.save}
						</Button>
					</DialogActions>
				</Dialog>
			</div>
		);
	}
}

class ListerDetails extends Component {
	render () {
		return (
			<div className="lister-right">
				<dl>
					<dt className="lister-secondary-text">{this.props.t.lister_installation_number}</dt>
					<dd>{this.props.installation}</dd>
					<dt className="lister-secondary-text">nr. {this.props.t.lister_inspection_body}</dt>
					<dd>{this.props.notified_body_number}</dd>
				</dl>
				<p className="lister-details-subtitle">{this.props.label}</p>
			</div>
		);
	}
}
export { Lister as default, ListItem, ListerInspection, ListerInstallation, ListerActions, ListerDetails };
